var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error404"},[_c('p',[_vm._v("404")]),_c('VanButton',{staticStyle:{"width":"100px"},attrs:{"size":"large","type":"text"},on:{"click":_vm.goHome}},[_vm._v("返回首页")]),_c('VanButton',{staticStyle:{"width":"100px","margin-left":"40px"},attrs:{"size":"large","type":"primary"},on:{"click":_vm.backPage}},[_vm._v("返回上一页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }